import { render } from "./CropModal.vue?vue&type=template&id=2f71d96a"
import script from "./CropModal.vue?vue&type=script&lang=js"
export * from "./CropModal.vue?vue&type=script&lang=js"

import "./CropModal.vue?vue&type=style&index=0&id=2f71d96a&lang=scss"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__